<template>
  <div class="componentBox">
    <h2 class="componentTitle">饲养信息</h2>
    <h3 class="littleTitle">饲养信息</h3>
    <Cell :colList="feedInfoCell" :detail="feedDetail" />
    <a-table class="tableBox" :columns="feedInfoColumns" :data-source="feedList" :pagination="false">
      <template slot="dayAge" slot-scope="t">
        {{ t?.toFixed(2) }}
      </template>
      <template slot="weight" slot-scope="t">
        {{ t?.toFixed(2) }}
      </template>
      <template slot="num" slot-scope="t">
        {{ t?.toFixed(2) }}
      </template>
    </a-table>
    <Cell :colList="feedStageCell" :detail="feedDetail" :len="2"/>
    <h3 class="littleTitle">饲养阶段</h3>
    <a-table class="tableBox" :columns="feedStageColumns" :data-source="pigLineRaiseInfos" :pagination="false">
      <template slot="stageType" slot-scope="t">
        {{ stagesObj[t] }}
      </template>
      <template slot="productName" slot-scope="t,r">
        <a v-if="r.nhfFormulaId && detail.pigLineCustomerInfo.createUser == staffId" @click="() => productDetail(r)">{{ t }}</a>
        <span v-else>{{ t }}</span>
      </template>
      <template slot="modelName" slot-scope="t">{{ t ? t : '-' }}</template>
      <template slot="feedTerminalPrice" slot-scope="t">
        {{ t?.toFixed(2) }}
      </template>
      <template slot="feedCost" slot-scope="t">
        {{ t?.toFixed(2) }}
      </template>
    </a-table>
    <h3 class="littleTitle">生产结果</h3>
    <Cell :colList="productionResultsCell" :detail="pigLineProductResult" :len="2"/>
    <h3 class="littleTitle">经济效益</h3>
    <Cell :colList="economicBenefits" :detail="pigLineProductResult" :len="2"/>
  </div>
</template>

<script>
import Cell from './Cell.vue';
import {feedInfoColumns,feedStageColumns} from '../Columns'
export default {
  components: {Cell},
  props: ['detail'],
  data() {
    return {
      stagesObj: {
        PIGLET: '教槽',
        CHILDCARE_BEFORE: '保育前期',
        CHILDCARE_AFTER: '保育后期',
        LITTLE_PIG: '仔猪',
        MEDIUM: '生长猪',
        FATTENING_PIG: '育肥猪',
        LARGE_PIG: '大猪',
      },
      feedInfoColumns,
      feedStageColumns,
      feedInfoCell: [
        {title: '饲养品种',field: 'feedVariety',},
        {title: '饲料品牌',field: 'feedBrand',},
        {title: '免疫情况',field: 'vaccinationName',},
      ],
      feedStageCell: [
        {title: '猪苗单价（元/头）',field: 'pigletPrice',},
        {title: '卖猪价（元/kg）',field: 'pigSalePrice',},
      ],
      productionResultsCell: [
        {title: '成活率（%）',field: 'survivalRate',},
        {title: '阶段总耗料（kg）',field: 'stageFeedCostTotal',},
        {title: '料肉比',field: 'weightCostRatio',},
        {title: '平均日采食量（kg/头）',field: 'avgFeedCost',},
        {title: '平均日增重（kg/头）',field: 'avgWeightIncrement',},
        {title: '阶段总增重（kg）',field: 'stageIncrementWeightTotal',},
      ],
      economicBenefits: [
        {title: '卖猪头均收入（元）',field: 'avgSaleProfit',},
        {title: '造肉成本（元/kg）',field: 'mealProductCost',},
        {title: '头均纯效益（元）',field: 'avgNetProfit',},
      ],
      staffId:''
    }
  },
  watch: {
    // detail:{
    //   handler(){
    //     this.feedDetail()
    //   },
    //   deep: true
    // }
  },
  computed: {
    feedDetail() {
      let obj = {...this.detail.pigLineFeedInfo}
      let {vaccination} = obj || {}
      if(vaccination){
        obj.vaccinationName = '是'
      } else {
        obj.vaccinationName = '否'
      }
      return obj
    },
    feedList() {
      let {intoDay,intoDayAge,avgInitialWeight,intoNum,outDay,outDayAge,avgEndWeight,outNum} = this.detail.pigLineFeedInfo || {}
      let feedList = [
        {state: '入栏',day: intoDay,dayAge: intoDayAge,weight: avgInitialWeight,num: intoNum},
        {state: '出栏',day: outDay,dayAge: outDayAge,weight: avgEndWeight,num: outNum},
      ]
      return feedList
    },
    pigLineRaiseInfos(){
      return this.detail.pigLineRaiseInfos || []
    },
    pigLineProductResult(){
      let {pigLineFeedInfo={},pigLineProductResult = {}} = this.detail || {}
      let obj = {...pigLineProductResult || {}}
      obj.totalWeight = pigLineFeedInfo.avgEndWeight - pigLineFeedInfo.avgInitialWeight
      return obj
    },
  },
  created() {},
  mounted() {this.staffId=window.localStorage.getItem('staffId')},
  methods: {
    productDetail(record){
      this.$http.get(`/nhf-app/api/sat/collect/formula/actions/check?formulaId=${record.nhfFormulaId}`).then(res => {
        if(res.code == 200){
          this.$router.push({
            path: '/nhf-compound-editor',
            query: {
              id: record.nhfFormulaId
            }
          })
        }
      })
    },
  }
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>